import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
  red: "#ff2d2d",
  black: {
    veryDark: "#0b0b0d",
    darker: "#14131a",
    lighter: "#1f1f28",
  },
  white: {
    lighter: "#f5f3ee",
    darker: "#b5b2ad",
  },
  gold: "#ffb347",
  teal: "#2ad1ff",
};
export default theme;
